/**
 * @file
 *
 * Takes an angler rank and returns the rank + its ordinal value.
 * I.E. 1 => 1st, 2 => 2nd, 3 => 3rd
 * It will also append the tieValue to the ordinal value unless includeTie is false
 *
 * @return Span value containing the ordinal value wrapped in the optional markup.
 */

import * as React from 'react';

// Utils
import { ordinal } from '../../util/util';

// Types
import { IAnglerRankRedis } from '../../types';

/**
 * Ordinal Rank
 */
interface IProps {
  // The rank object from the angler JSON object
  rank: IAnglerRankRedis;
  // Optional markup to append the ordinal result
  suffixMarkup?: string;
  // Optional markup to prepend the ordinal result
  prefixMarkup?: string;
  // boolean (string) to dictate if the tie flag should be shown
  includeTie?: boolean;
}
const ordinalRank: React.FunctionComponent<IProps> = ({
  rank,
  suffixMarkup,
  prefixMarkup,
  includeTie,
}) => {
  const rankNum = parseInt(rank['#'], 10);
  const tieValue = rank['@'].TIE === 'Y' ? ' (T)' : '';

  const ordinalText = ordinal(rankNum);
  const suffixValue = includeTie ? `${tieValue}${suffixMarkup}` : suffixMarkup;

  return (
    <span className="leaderboard-list__angler-rank">
      {prefixMarkup}
      {ordinalText}
      {suffixValue}
    </span>
  );
};

ordinalRank.defaultProps = {
  includeTie: true,
  prefixMarkup: '',
  suffixMarkup: '',
};

export default ordinalRank;
